<template>
  <swiper-slide class="swiper6">
    <head-bar
      :main_title="main_title"
      :isT="1"
    ></head-bar>
    <div class="contanier">
      <div class="highschool">
        <!-- <div
          class="box box1"
          :class="{active:active === 'active1'}"
        >
          <div class="zjtop">
            <img src="../assets/5lab/zjdxbg.png">
          </div>
          <div class="text">浙大全拓联合实验室</div>
          <div class="bottom">
            <ul>
              <li>通过人工智能等技术实现智能化标签模型;</li>
              <li>对用户设备号自动打标签;</li>
              <li>一个模型可以输出多标签体系;</li>
            </ul>
          </div>
        </div> -->
        <div
          class="box box2 "
          :class="{active:active === 'active2'}"
        >
          <div class="top">
            <img src="../assets/5lab/上海学校bg.png">
          </div>
          <div class="text">上海交大APEX实验室</div>
          <div class="bottom">
            <ul>
              <li>APEX数据与知识管理实验室;</li>
              <li>大数据挖掘、计算广告、信息检索、个性化推荐系统等;</li>
              <li>人工智能和机器学习技术;</li>
              <li>深度乘法神经网络用于全拓广告个性化推荐引擎业务场景中;</li>
            </ul>
          </div>
        </div>
        <div
          class="box box3"
          :class="{active:active === 'active3'}"
        >
          <div class="top">
            <img src="../assets/5lab/上海学校bg.png">
          </div>
          <div class="text">上海交大安泰-全拓治理实验室</div>
          <div class="bottom">
            <ul>
              <li>共同推动基于大数据、区块链、5G、物联网、人工智能等新型基础设施驱动的数据治理平台体系的建设；</li>
              <li>基于具体的应用场景，通过联合技术研发和商业模式创新，推动数据治理平台体系在全国范围的落地应用和普及推广；</li>
            </ul>
          </div>
        </div>
        <div
          class="box box4"
          :class="{active:active === 'active4'}"
        >
          <div class="zjtop">
            <img src="../assets/5lab/浙江学校bg.png">
          </div>
          <div class="text">浙工大全拓大数据联合实验室</div>
          <div class="bottom">
            <ul>
              <li>合作课题研究、项目开发以及重大课题的申报；</li>
              <li>企信通、短视频生态服务平台、短视频直播营销平台等项目的研发；</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="mofangwrap">
        <div class="mofang">
         <mofang></mofang>
        </div>
      </div>
     
    </div>

  </swiper-slide>
</template>
<script>
import headBar from '../components/headBar.vue'
import mofang from '../components/mofang.vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.min.css'


export default {
  name: 'lab',
  components: {
    swiper,
    swiperSlide,
    headBar,
    mofang
  },
  data() {
    return {
      main_title: require('../assets/5lab/title5.png'),
      active: 'active1' //当前放大对象
    }
  },
  methods: {
    changeActive() {
      let index = 1
      setInterval(() => {
        if (index > 3) return (index = 1)
        this.active = `active${index}`
        index++
      }, 1500)
    }
  },
  created() {
    this.changeActive()
  },
  mounted() {}
}
</script>
<style lang="less" scoped>
@import '../style/lab.less';
</style>